import {Component, OnInit} from '@angular/core';
import {Customer} from '../../../dto/customer';
import {formatPhoneNumeric, phoneToCountry, toDateString} from "../../../providers/app-date-adapter";
import {ActivatedRoute, Params, Router} from '@angular/router';
import {CustomersService} from '../../services/customers.service';
import {Location} from '@angular/common';
import {CardsService} from '../../services/cards.service';
import {EventLogService} from '../../../services/crud/event-log.service';
import {ObjectCommentsService} from '../../services/object-comment.service';
import {RoleService} from '../../../services/role.service';
import {OrdersService} from '../../services/orders.service';
import {WebIdTransactionService} from '../../services/webid-transaction.service';
import {FileHelper} from '../../../helpers/file-helper';
import {Country} from '../../../dto/country';
import {CountryService} from '../../../services';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ProductService} from '../../services/product.service';
import {InvoicesService} from '../../services/invoices.service';
import {PrevNextModel} from '../../../models/prev-next-model';
import {getTableFilters} from '../../../helpers/storage-helper';

import {SendUploadLinkDialogComponent} from '../../../shared/send-upload-link/send-upload-link-dialog.component';
import {SendUploadLinkModel} from '../../../models/send-upload-link-model';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {
  AddressConfirmDialogComponent
} from '../../../shared/confirm-dialog/address-confirm-dialog/address-confirm-dialog.component';
import {AddressCustomersService} from '../../services/address-customers.service';
import {AddressUploadDto} from '../../../dto/address-upload';
import {CustomerChangeAddressStatusModel} from '../../../models/customer-change-address-status-model';
import {BadgeService} from '../../services/badge.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {IdentLevel} from '../../../dto/ident-status';
import {ContentRowField} from '../../../shared/content-row/content-row.component';
import {AddressUpdateModel} from "../../../models/address-update-model";
import {ToastService} from "angular-toastify";
import {UploadLink} from "../../../dto/upload-link";
import {ConfirmDialogComponent} from "../../../shared/confirm-dialog/confirm-dialog.component";
import {MarkCustomerAsVulnerableModel} from "../../../models/mark-customer-as-vulnerable-model";
import {MarkVulnerableDialogComponent} from "../../customers/mark-vulnerable-dialog/mark-vulnerable-dialog.component";


@Component({
  selector: 'app-address-customer-overview-detail',
  templateUrl: './address-customer-overview-detail.component.html',
  styleUrls: ['./address-customer-overview-detail.component.css']
})
export class AddressCustomerOverviewDetailComponent implements OnInit {

  customerId: number;
  addressUploadFiles: AddressUploadDto[];
  newAddressUploadFiles: AddressUploadDto[];
  prevNext: PrevNextModel;
  customer: Customer;
  isFrameHidden = true;
  isImgHidden = true;
  filename = null;
  errorMsg = null;

  countries: Country[];

  urlSafe: SafeResourceUrl;
  fields = [
    {
      header: 'Customer',
      icon: (row: Customer) => 'visibility',
      link: (row: Customer) => '../../customers-overview/' + (row.id || ''),
      cell: (row: Customer) => `${row.title} ${row.firstName} ${row.lastName}`
    } as ContentRowField<Customer>,
    {header: 'Email', cell: (row: Customer) => `${row.email || ''}`},
    {header: 'Mobile', cellFlag: (row: Customer) => phoneToCountry(''+row.phone), cell: (row: Customer) => `+${row.phone || ''}`},
    {header: 'Date of birth', cell: (row: Customer) => `${toDateString(row.dob) || ''}`},
    {header: 'Address', cell: (row: Customer) => `${row.address || ''}, ${row.zipCode || ''} ${row.city || ''}`},
    {header: 'Country', cell: (row: Customer) => `${row.countryName || ''}`},



    {header: 'IP Address', cell: (row: Customer) => `${row.ipAddress || ''}`},

  ] as ContentRowField<Customer>[];
  isDocsResendUploadLinkDisabled = true;
  isSaveAddressDisabled = true;
  isSaving = false;
  addressForm: FormGroup;
  openUploadLinks: UploadLink[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private customersService: CustomersService,
    private addressCustomersService: AddressCustomersService,
    private roleService: RoleService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private countryService: CountryService,
    public sanitizer: DomSanitizer,
    private badgeService: BadgeService,
    private _toastService: ToastService,
  ) {
  }

  ngOnInit() {
    this.countryService.getMany().subscribe(result => {
      this.countries = result.data;
    });

    this.route.params.subscribe((params: Params) => {
      const idParam = params['id'];
      this.customerId = idParam;
      this.clearData();
      this.refreshCustomer();
      this.refreshOpenUploadLinks();
      this.getPrevNext(idParam);

      this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl('');

    });
  }

  currentUserIsAdmin(): boolean {
    return this.roleService.hasRoles('admin');
  }

  currentUserIsSuperAdmin(): boolean {
    return this.roleService.hasRoles( 'super_admin' );
  }

  currentUserIsAdminOrManager(): boolean {
    return this.roleService.hasRoles(['admin', 'manager']);
  }

  currentUserIsAdminOrManagerOrAgent(): boolean {
    return this.roleService.hasRoles(['admin', 'manager', 'agent']);
  }

  isAddressDisabled(customer: Customer) {
    if (customer.archived) {
      return true;
    }

    return !this.roleService.hasRoles(['admin', 'manager', 'partner', 'partner_support']);
  }

  showMessage(msg: string) {
    this._toastService.info(msg);
  }

  returnBack() {
    this.location.back();
  }

  openFile(fileId: number) {
    this.customersService.getFileInline(fileId).subscribe(
      result => {

        const disposition = result.headers.get('Content-Disposition');
        const contentType = result.headers.get('Content-Type');
        const filename = disposition.split(';')[1].trim().split('=')[1];

        const blob = new Blob([result.body], {type: contentType});
        //FileSaver.saveAs(blob , filename);
        const fileURL = URL.createObjectURL(blob);


        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);

        if (contentType.indexOf('image') >= 0) {
          this.isImgHidden = false;
          this.isFrameHidden = true;

        } else {
          this.isImgHidden = true;
          this.isFrameHidden = false;

        }
        this.errorMsg = null;
        this.filename = filename;


        //FileHelper.saveFile( result );
      },
      err => {
        this.filename = null;
        this.isImgHidden = true;
        this.isFrameHidden = true;
        this.errorMsg = 'Error occured during downloading the file.';

        this.snackBar.open(err.error.message || err.message || err.error || err, null, {
          duration: 5000,
          panelClass: ['app-mat-snack-bar']
        });
      }
    );
  }

  downloadFile(fileId: number) {
    this.customersService.getFile(fileId).subscribe(
      result => {
        FileHelper.saveFile(result);
      },
      err =>
        this.snackBar.open(err.error.message || err.message || err.error || err, null, {
          duration: 5000,
          panelClass: ['app-mat-snack-bar']
        })
    );
  }

  refreshCustomer() {
    this.isSaveAddressDisabled = true;

    this.customersService.get(this.customerId).subscribe(data => {
      this.customer = data;
      this.initForm(this.customer);

      this.customersService.getOnlyAddressFiles(this.customerId).subscribe(data => {

        this.addressUploadFiles = data;
        this.newAddressUploadFiles = [];

        this.addressUploadFiles.forEach(file => {
          if (file.mailSentDate == null) {
            this.isSaveAddressDisabled = false;
            this.newAddressUploadFiles.push(file);
          }
        });



        if (!this.roleService.hasRoles(['super_admin', 'compliance', 'manager', 'finance_manager'])) {
          this.isSaveAddressDisabled = true;
        }

      });
    });
  }

  refreshOpenUploadLinks() {
      this.customersService.getOpenUploadLinks(this.customerId).subscribe(data => {
        this.openUploadLinks = data;
      });
  }

  getOrdersTableFilters() {
    const a = getTableFilters('customerTable');
    return a;
  }

  getPrevNext(id: number) {
    const filters = this.getOrdersTableFilters();
    this.addressCustomersService.getPrevNext(filters, id).subscribe(result => {
      this.prevNext = result;
    });
  }

  gotoPrevCustomer() {
    const filters = this.getOrdersTableFilters();
    this.addressCustomersService.getPrev(filters, this.customerId).subscribe(result => {
      this.router.navigate(['..', result], {relativeTo: this.route});
    });
  }

  gotoNextCustomer() {
    const filters = this.getOrdersTableFilters();
    this.addressCustomersService.getNext(filters, this.customerId).subscribe(result => {
      this.router.navigate(['..', result], {relativeTo: this.route});
    });
  }

  clearData() {
    this.prevNext = null;
  }

  sendAddressLink(customer: Customer) {
    this.dialog.open(SendUploadLinkDialogComponent, {
      data: {
        email: customer.email,
      },
    }).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof SendUploadLinkModel) {
          dlgResult.customerId = customer.id;
          dlgResult.typeId = 3;

          this.customersService.sendUploadLink(dlgResult).subscribe(result => {
            this.snackBar.open('Uploadlink sent.', null, {
              duration: 5000,
              panelClass: ['app-mat-snack-bar']
            });
          });

          this.refreshCustomer();
        }
      });
  }

  initForm(customer: Customer) {
    this.addressForm = this.formBuilder.group(customer);
  }

  showChangeAddress(files: AddressUploadDto[]) {

    if (files == null || files.length < 1) {
      return false;
    }

    const t: AddressUploadDto[] = [];

    files.forEach(function (f) {
      if (f.mailSentDate == null) {
        t.push(f);
      }
    });

    let isOk = true;
    let type: number;
    let oneFileOk = false;

    t.forEach(function (file) {
      if (file.isSuccess == null) {
        isOk = false;
      }
      if (file.isSuccess) {
        oneFileOk = true;
      }

      type = file.typId;
    });

    return oneFileOk;
  }

  save(files: AddressUploadDto[]) {

    const t: AddressUploadDto[] = [];

    files.forEach(function (f) {
      if (f.mailSentDate == null) {
        t.push(f);
      }
    });

    let isOk = true;
    let type: number;
    let anyFilesOk = false;

    let nonCheckedFiles = files.filter(value => value.isSuccess === null);
    if ( nonCheckedFiles.length > 0 ) {
      alert('Not all documents are marked/reviewed.');
      return;
    }

    let okFiles = files.filter(value => value.isSuccess === true);
    if ( okFiles.length > 0) {
      type = okFiles[0].typId;
      anyFilesOk = true;
    }

    console.log("OkFiles");
    console.log(JSON.stringify(okFiles, null, 2));

    if (anyFilesOk) {
      let addresseCheck = true;
      if (this.addressForm.controls['zipCode'].value == '') {
        addresseCheck = false;
      }
      if (this.addressForm.controls['address'].value == '') {
        addresseCheck = false;
      }
      if (this.addressForm.controls['city'].value == '') {
        addresseCheck = false;
      }

      if (!addresseCheck) {
        alert('Not all fields of the new address are filled.');
        return;
      }
    }

    const isSuccess = null;
    let dialogTitle = '';

    const dialogStatusName = anyFilesOk ? 'Success' : 'Failed';
    dialogTitle = 'Send "' + dialogStatusName + '" to Customer?';

    let showFailReasonDropDown = !anyFilesOk;

    this.dialog.open(AddressConfirmDialogComponent, {
      data: {
        title: dialogTitle,
        text: 'Are you sure you want to save and send a message to the customer?',
        confirm: 'Ok',
        cancel: 'Cancel',
        showFailReasonDropDown: showFailReasonDropDown,
      },
    }).afterClosed()
      .subscribe((dlgResult: AddressUpdateModel) => {
        if (dlgResult?.confirmed) {

          this.isSaving = true;

          this.addressCustomersService.saveAddressFiles(t).subscribe(result => {
            const model = new CustomerChangeAddressStatusModel();

            model.customer = this.customer;
            model.isSuccess = anyFilesOk;
            model.files = t;

            if (anyFilesOk) {
              model.customer = this.addressForm.value;
            }
            model.customer.orders = null;
            model.customer.cards = null;

            if (showFailReasonDropDown)
              model.failReasonCode = dlgResult?.failReasonCode

            this.addressCustomersService.saveAddressFilesAndSendEmail(model).subscribe(result => {

              this._toastService.success('saved and e-mail sent');

              this.refreshCustomer();
              this.badgeService.refreshBadge('compliance');

              this.isSaving = false;

            }, err => {
              this.isSaving = false;
              this._toastService.error(err.error.message || err.message || err.error || err)
            });
          }, err => {
            this.isSaving = false;
            this._toastService.error(err.error.message || err.message || err.error || err)
          });
        }
      });
  }

  getAddressUploadTypeText(f: AddressUploadDto) {
    if ( f.typId == 3 )
      return "Address Change"
    if ( f.typId == 6 )
      return "Address Confirmation"

    return f.typName;
  }

  markAsVulnerable(customer: Customer) {

    this.isMarkingAsVulnerable = true;
    const dialogRef = this.dialog.open(MarkVulnerableDialogComponent, {
      data: {
        title: 'Mark customer as vulnerable',
        text: 'Are you sure want to mark this customer as vulnerable?'
      },
      minWidth: 350,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result instanceof MarkCustomerAsVulnerableModel) {
        this.customersService.markVulnerable(customer.id, result.reason, 'POA').subscribe(_ => {
          this.customer.isVulnerable = true;
          this.customer.vulnerableDate = new Date();
          this.customer.vulnerableReason = result.reason;
          this._toastService.info('Customer was marked as vulnerable');
          this.isMarkingAsVulnerable = false;
        });
      } else {
        this.isMarkingAsVulnerable = false;
      }
    });



  }
  isMarkingAsVulnerable = false;
}
